import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ContractStatement extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    fetchResult(req) {
        return this.repo.getContractStatement(req);
    }
}
export default ContractStatement;
